import React, { Component, Fragment } from 'react';
import HttpRequestor from '../utils/http_requestor';
import I18n from '~/utils/translations';

export default class ResendConfirmation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      resubmitted: false,
      resubmitting: false,
    };
  }

  render() {
    return (
      <Fragment>
        <p className="about-you__context">
          {this.state.resubmitted
            ? I18n.t('login_or_signup.upcoming_viewing.resubmitted')
            : I18n.t('login_or_signup.upcoming_viewing.text')}
        </p>
        {!this.state.resubmitted && (
          <button
            className={`about-you__button ${this.state.resubmitting ? 'loading' : ''}`}
            onClick={this.resendConfirmation}
            disabled={this.state.resubmitting}
          >
            {I18n.t('login_or_signup.upcoming_viewing.button')}
          </button>
        )}
      </Fragment>
    );
  }

  get resendConfirmationUrl() {
    return `/homes/${this.props.propertyId}/viewings/resend`;
  }

  resendConfirmation = (_e) => {
    this._resendRequest();
  };

  _resendRequest = () => {
    this.setState({ resubmitting: true });
    const requestor = new HttpRequestor();
    requestor
      .call(this.resendConfirmationUrl, 'POST', {
        data: {
          type: 'viewing',
          attributes: {
            email: this.props.userEmail,
          },
        },
      })
      .then(this._resendSuccess)
      .catch(this._resendError);
  };

  _resendSuccess = (_response) => {
    this.setState({ resubmitting: false, resubmitted: true });
  };

  _resendError = (_response) => {
    this.setState({ resubmitting: false, submitError: 'Something went wrong, please try again' });
  };
}
